type TableHeaderCellProps = {
    t: (key: string) => string;
    translate_token: string;
};

function TableHeaderCell({ t, translate_token }: Readonly<TableHeaderCellProps>) {
    return <span className="text-xs">{t(translate_token)}</span>;
}

export default TableHeaderCell;
